import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'math-equal-lower', 'MathEqualLower', [["path",{"d":"M19 18l-14 -4"}],["path",{"d":"M19 14l-14 -4l14 -4"}]]);